<script lang="ts">
	import type { DeviceGroup } from "luxedo-data"
	import GroupNetworkMenu from "./group-network-menu/GroupNetworkMenu.svelte"

	interface Props {
		group: DeviceGroup
	}

	let { group }: Props = $props()
</script>

<GroupNetworkMenu {group} />

<style>
</style>
